import React from 'react'
import Image from 'next/image'
import cx from 'classnames'

import { Column, Row, Rows } from '@/components/layout'
import guaranteeBadgeImg from '@/assets/buy-flow/right-side/cc--guarantee-badge.png'

import styles from './CheckoutSideCreditCardNeatHome.module.scss'

export default function CheckoutSideCreditCardNeatHome() {
  return (
    <Column className={styles.background} gap={32} size={66}>
      <div className={styles.pinkBox}>
        <Row className={styles.headerRow} gap={0}>
          <Column size={66}>
            <Rows className="max-w-500" gap={0}>
              <h1 className={cx(styles.headLine, styles.headLineSpacing)}>
                You're Almost Ready to Start with NeatHome
              </h1>
            </Rows>
          </Column>
        </Row>
        <Row className={styles.textRow}>
          <Image alt="30-day money back guarantee" src={guaranteeBadgeImg} style={{ height: 'auto' }} width={300} />
          <p className={styles.promiseBlock}>
            We also offer a full 30-day money-back guarantee should NeatHome not be the right solution for you.
          </p>
        </Row>
      </div>
    </Column>
  )
}
